/**
 * カテゴリコード → 表示ラベル整形ヘルパー (docs/107 Wave 10、old2 `lib/categoryFormat.ts` 踏襲)。
 *
 * old2 は 2 形式を使い分けていた:
 *   - `formatCategoryLabel`: "D-09 眺望・景観【環境・自然】" (投稿詳細 / モデレーション向け、コード付き full)
 *   - `formatCategoryTag`:   "眺望・景観【環境・自然】" (chip 短縮、ECW DetailPanel 向け)
 *
 * v2 では `AiCategoryMasterRow` (majorCd / categoryCd / category / major) を解決済 row として受け取る。
 * row 未解決時 (master fetch 前 / code が master に無い) は code をそのまま返す (old2 と同じ degrade)。
 */
import type { AiCategoryMasterRow } from '@citizen-walk/shared-types';

/** "D-09 眺望・景観【環境・自然】" 形式 (投稿詳細・モデレーション向け、コード付き)。 */
export function formatCategoryLabel(code: string, row: AiCategoryMasterRow | undefined): string {
  if (!row) return code;
  return `${row.majorCd}-${row.categoryCd} ${row.category}【${row.major}】`;
}

/**
 * "眺望・景観【環境・自然】" 形式 (chip 短縮、ECW DetailPanel 向け)。
 * old2 `formatCategoryTag` 踏襲 — code を省き category【major】のみ。
 */
export function formatCategoryTag(code: string, row: AiCategoryMasterRow | undefined): string {
  if (!row) return code;
  return `${row.category}【${row.major}】`;
}
